import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

export const ChoiceCard = ({ selected, onClick, testId, children, className }) => (
  <button
    type="button"
    role="radio"
    aria-checked={selected}
    onClick={onClick}
    data-testid={testId}
    data-selected={selected}
    className={cn(
      "rc-card group relative flex flex-col rounded-2xl border bg-card p-4 text-left transition-[border-color,box-shadow,transform] duration-200",
      "hover:-translate-y-0.5 hover:border-primary/50 hover:shadow-[0_18px_40px_-24px_hsl(var(--primary)/0.5)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
      selected && "border-primary ring-2 ring-primary/25",
      className
    )}
  >
    {selected && (
      <span className="absolute right-3 top-3 z-10 flex h-6 w-6 items-center justify-center rounded-full bg-primary text-primary-foreground">
        <Check className="h-3.5 w-3.5" />
      </span>
    )}
    {children}
  </button>
);
